import SafeAppsSDK from '@safe-global/safe-apps-sdk';
import { useEffect, useState } from 'react';

export const useIsSafeWalletContext = () => {
  const isIframe = typeof window !== 'undefined' && window?.parent !== window;
  const [safeWalletContext, setSafeWalletContext] = useState(false);

  const processContext = async () => {
    if (!isIframe) {
      setSafeWalletContext(false);
      return;
    }

    const safeSdk = new SafeAppsSDK();

    const safeInfo = await Promise.race([
      safeSdk.safe.getInfo(),
      new Promise<undefined>((resolve) => setTimeout(resolve, 200)),
    ]);

    if (!!safeInfo) {
      setSafeWalletContext(true);
    }
  };

  useEffect(() => {
    processContext();
  }, []);

  return safeWalletContext;
};
